
import PageJS from './top/page';
import CommonJS from './common';


// --------------------
const common = new CommonJS();
const page = new PageJS(common);
page.init();